import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    price: '',
    questions: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const amaSlice = createSlice({
  name: 'ama',
  initialState,
  reducers: {
    amaStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        price: blockContent?.price ?? '',
        questions: blockContent?.questions ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    amaClear: () => initialState,

    amaUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    amaUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    amaUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { amaStore, amaClear, amaUpdateIsLoading, amaUpdateIsActive, amaUpdateBlockContent } = amaSlice.actions;

export const selectAmaIsLoading = (state) => state.ama.isLoading;

export const selectAmaId = (state) => state.ama.id;
export const selectAmaUID = (state) => state.ama.uid;
export const selectAmaSID = (state) => state.ama.sid;

export const selectAmaBlockContent = (state) => state.ama.blockContent;
export const selectAmaItemDesign = (state) => state.ama.itemDesign;
export const selectAmaContainerDesign = (state) => state.ama.containerDesign;

export default amaSlice.reducer;
